<div class="modal-header">
    <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
            <ion-col size="9"
                     class="ion-no-padding">
                {{ 'TIMESLOTS_ADD_NOTE_MODAL_HEADER' | translate }}
            </ion-col>
            <ion-col size="3"
                     class="ion-no-padding ion-text-right">
                <a *ngIf="note?.length"
                   (click)="deleteNote()"
                   class="delete-note"
                   [title]="'TIMESLOT_DELETE_NOTE_TITLE' | translate">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-trashcan.svg"
                              class="icon fill-dark">
                    </svg-icon>
                </a>
                <a (click)="close()">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-close.svg"
                              class="icon fill-dark">
                    </svg-icon>
                </a>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>

<form method="get"
      #f="ngForm"
      role="form"
      novalidate
      class="ion-padding">
    <ion-row class="ion-no-padding">
        <ion-col class="ion-no-padding">
            <ion-item class="note-item ion-no-padding"
                      [ngClass]="{ 'has-error': error }">
                <ion-textarea placeholder="{{ 'TIMESLOTS_NOTE_PLACEHOLDER' | translate }}"
                              ieTextareaFix
                              name="noteInput"
                              inputmode="text"
                              spellcheck="false"
                              autocapitalize="off"
                              [autofocus]="true"
                              #noteInput="ngModel"
                              [(ngModel)]="note">
                </ion-textarea>
            </ion-item>
        </ion-col>
    </ion-row>
    <ion-row *ngIf="error"
             class="ion-no-padding">
        <ion-col class="ion-no-padding">
            <div class="error-message">
                {{ error }}
            </div>
        </ion-col>
    </ion-row>
    <ion-row class="ion-no-padding">
        <ion-col class="ion-no-padding ion-text-right">
            <ion-button class="btn-close"
                        color=""
                        (click)="close()">
                {{ 'BUTTON_CANCEL' | translate }}
            </ion-button>
            <ion-button color="primary"
                        [disabled]="!note"
                        (click)="addNote(f.form.valid)">
                {{ 'BUTTON_ADD' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</form>